<template>
  <div>
    <div class="h1">
      <div class="w">
        <img src="../../assets/img/pagess/gdd107/022.png" alt="" />

        <div class="text">投资有风险，入市需谨慎！</div>
      </div>
    </div>

    <div class="h2">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn1.png"
          alt=""
        />
      </div>
    </div>

    <div class="h3"></div>

    <div class="h4">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn1.png"
          alt=""
        />
      </div>
    </div>

    <div class="h5">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn1.png"
          alt=""
        />
      </div>
    </div>

    <div class="h6">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn2.png"
          alt=""
        />
      </div>
    </div>

    <div class="h7">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn2.png"
          alt=""
        />
      </div>
    </div>

    <div class="h8">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn2.png"
          alt=""
        />
      </div>
    </div>

    <div class="h9">
      <div class="w">
        <img
          @click="to_xaizai()"
          class="btn"
          src="../../assets/img/pagess/gdd107/btn1.png"
          alt=""
        />
      </div>
    </div>

    <div class="bottomsss">
      <div class="boxx"></div>

      <p>————&nbsp;投资有风险入市需谨慎&nbsp;————</p>

      <p>
        从事证券投资或期货交易，请通过合法证券期货经营机构进行&nbsp;&nbsp;&nbsp;合法机构名单可到中国证监会网站
        (

        <a href="http://www.csrc.gov.cn/">www.csrc.gov.cn</a>)查询
      </p>

      <p>
        北京天相财富管理顾问有限公司 &nbsp;&nbsp;&nbsp;

        <a href="https://beian.miit.gov.cn/">京ICP备16068579号-1</a
        >&nbsp;&nbsp;&nbsp; 执证编号：91110102MA001GJE1N
      </p>

      <p>天相股多多软件版本号：v1.3.1.1288 更新时间：2022年2月</p>

      <p style="text-decoration: underline; cursor: pointer" class="qwer">
        <!-- 联系电话:010-********&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->

        <span @click="open_yinsi()" style="margin-right: 10px"
          >隐私保护政策</span
        >

        <span @click="open_fuwuxieyi()">软件服务协议</span>
      </p>

      <p>开发者名称:北京天相财富管理顾问有限公司</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      res: false,
    };
  },
  mounted() {
    this.clientIp();
  },
  methods: {
    open_yinsi() {
      window.open("https://cdn.juniubang.com/apk/隐私政策4.7.pdf");
    },
    open_fuwuxieyi() {
      window.open("https://cdn.juniubang.com/apk/许可使用协议4.7.pdf");
    },
    to_xaizai() {
      this.post_leilei_data();
      // window.open("https://cdn.juniubang.com/apk/GDD1001.exe");
    },
    // 给磊磊传页面数据
    post_leilei_data() {
      this.$http
        .post("/to_exe", {
          qhclickid: this.$route.query.sourceid,
          url: window.location.href,
          code: this.$route.query.code,
          type: "360",
        })
        .then((res) => { window.open(res.data.message);});
    },

    clientIp() {
      this.$http
        .post("/client_ip", { url: window.location.href })
        .then((res) => {
          window.localStorage.setItem("_number", res.data);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.btn {
  animation: breathe 1.1s infinite;
}

@keyframes breathe {
  0% {
    transform: scale(0.99);
  }
  50% {
    transform: scale(1.03);
  }
  100% {
    transform: scale(0.99);
  }
}

img {
  display: block;
}

.h1 {
  width: 100%;
  height: 301px;
  background: url(../../assets/img/pagess/gdd107/index_01.jpg) no-repeat center;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text {
      font-size: 30px;
      font-weight: 600;
    }
  }
}

.h2 {
  width: 100%;
  height: 318px;
  background: url(../../assets/img/pagess/gdd107/index_02.jpg) no-repeat center;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
  }
}

.h3 {
  width: 100%;
  height: 367px;
  background: url(../../assets/img/pagess/gdd107/index_03.jpg) no-repeat center;
}

.h4 {
  width: 100%;
  height: 353px;
  background: url(../../assets/img/pagess/gdd107/index_04.jpg) no-repeat center;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 205px;
  }
}

.h5 {
  width: 100%;
  height: 364px;
  background: url(../../assets/img/pagess/gdd107/index_05.jpg) no-repeat center;
  .w {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 235px;
  }
}

.h6 {
  width: 100%;
  height: 361px;
  background: url(../../assets/img/pagess/gdd107/index_06.jpg) no-repeat center;
  .w {
    width: 680px;
    margin: 0 auto;
    display: flex;
    padding-top: 255px;
  }
}

.h7 {
  width: 100%;
  height: 364px;
  background: url(../../assets/img/pagess/gdd107/index_07.jpg) no-repeat center;
  .w {
    width: 680px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    padding-top: 255px;
  }
}

.h8 {
  width: 100%;
  height: 364px;
  background: url(../../assets/img/pagess/gdd107/index_08.jpg) no-repeat center;
  .w {
    width: 680px;
    margin: 0 auto;
    display: flex;
    padding-top: 230px;
  }
}

.h9 {
  width: 100%;
  height: 272px;
  background: url(../../assets/img/pagess/gdd107/index_09.jpg) no-repeat center;
  .w {
    width: 680px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    padding-top: 140px;
  }
}

.bottomsss {
  width: 100%;
  height: 150px;
  background-color: #f0ede4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  font-size: 12px;
  .boxx {
    width: 100%;
    height: 30px;
  }
  .qwer span:hover {
    color: red;
  }
  a {
    font-size: 12px;
    color: rgb(7, 7, 7);
  }
  p {
    margin: 0;
    font-size: 12px;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pagess/gdd159.vue